import { render, staticRenderFns } from "./sponsorship_know_people.vue?vue&type=template&id=1c7481fa&"
import script from "./sponsorship_know_people.vue?vue&type=script&lang=js&"
export * from "./sponsorship_know_people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports